export default "__VITE_ASSET__43bf7fae__"